import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { getUrls } from "services/api.enums";

export const filterDesOrganizationDetails: AsyncThunk<{}, {}, {}> =
  createAsyncThunk("desOrganizationDetails",  async (body: any) => {
      const data = await filterTableDataAPI(
        "/consignment-api/anomalyDetail/v1/s0/detailInformation",
        body.pageNumber,
        { ...body, pageNumber: undefined, pageSize: undefined },
        true,
        10,
        false
      )
      
      return data.data.response
  })

const initialState: any = {
  desOrganizationDetailsData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const DesOrganizationDetailsSlice = createSlice({
  initialState: initialState,
  name: "desOrganizationDetails",
  reducers: {
    clearDesOrganizationDetails: (state) => {
      state.desOrganizationDetailsData = [];
    },
    setFilterDesorganizationDetails: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterDesOrganizationDetails.fulfilled as any]: (state, action) => {
      state.desOrganizationDetailsData = action.payload;
      state.fetchpost = false;
    },
    [filterDesOrganizationDetails.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterDesOrganizationDetails.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterDesorganizationDetails, clearDesOrganizationDetails } =
  DesOrganizationDetailsSlice.actions;
export default DesOrganizationDetailsSlice.reducer;
